<template>
  <main-layout>
    <template #header>
      <main-header :title="'배치 확인' | translate" />
    </template>
    <template #feature />
    <template #toolbar>
      <!--상단 select box 와 버튼 부분 시작-->
      <main-toolbar>
        <div style="width: 150px;">
          <admin-date-picker
              :label="'확인 할 날짜'"
              :date.sync="searchOptions.checkDate"
          />
        </div>
        <div class="ml-3">
          <search-single-select-box
              :items="options.batchList"
              :label="'배치'"
              style="width: 200px;"
              :value.sync="searchOptions.batchType"
              :clearable="false"
              @update:selected="onFilterChanged"
          />
        </div>
        <div v-if="searchOptions.batchType == 'F'">
          <v-checkbox
              v-model="searchOptions.confirmTaxStepYn"
              true-value="Y"
              false-value="N"
              :label="'세금계산서 확인 포함'"
          />
        </div>
        <div>
          <search-select-auto-complete
              v-if="searchOptions.batchType !== 'F'"
              v-model="searchOptions.rentalcompanyId"
              :items="companyOptions"
              :label="'임대업체' | translate"
              class="sales-select-box-style"
          />
        </div>
        <div v-if="searchOptions.batchType === 'T'">
          <v-checkbox
              v-model="searchOptions.autoYn"
              true-value="Y"
              false-value="N"
              :label="'세금계산서 자동화 사용만 보기'"
          />
        </div>

        <v-btn elevation="0" color="#F9FCFF"
               @click="identifier++"
        >
          <v-icon color="#0C98FE">
            mdi-check-outline
          </v-icon>
          확인 하기
        </v-btn>
      </main-toolbar>
      <!--상단 select box 와 버튼 부분 끝-->
    </template>
    <template #body>
    <component
      :is="currentPage.component"
      :search-options="searchOptions"
      :identifier="identifier"
      @open-modal="openModal"
    />
    </template>
    <BatchModal v-if="isModal"
                @closeModal="closeModal"
                @saveModal="saveModal"
    >
      <content>
        <div class="modal__title">
          {{ selectedBatchType }}
        </div>
        <span class="modal__close" @click.stop="closeModal">CLOSE</span>
        <div class="modal__detail">
          <table>
            <tr>
              <th>임대업체 </th>
              <td>{{ modalItem.rentalcompanyName }}{{ '(' + modalItem.rentalcompanyId + ')' }}</td>
            </tr>
            <tr>
              <th>거래처</th>
              <td>{{ modalItem.accountName }}{{ '(' + modalItem.accountId + ')' }}</td>
            </tr>
            <tr>
              <th>상태</th>
              <td>{{ modalItem.resultValue == null ? '' : modalItem.resultValue + '/' }}{{ modalItem.message == null ? '' : modalItem.message + '/' }}{{ modalItem.type == null ? '' : modalItem.type }}</td>
            </tr>
            <tr>
              <th>사유</th>
              <td>
                <textarea v-model="modalItem.detailReason" />
              </td>
            </tr>
          </table>
        </div>
        <div class="modal__footer">
          <button label="Save" @click.stop="saveModal">
            Save
          </button>
          <button v-if="searchOptions.batchType == 'FL'" label="Delete" @click.stop="deleteModal">
            Delete
          </button>
        </div>
      </content>
    </BatchModal>
  </main-layout>
</template>

<script>
import {PATH} from "@/constants";
import AdminDatePicker from "@/components/input/AdminDatePicker";
import MainBody from "@/components/common/layout/MainBody";
import MainHeader from "@/components/common/layout/MainHeader";
import MainLayout from "@/components/common/layout/MainLayout";
import MainToolbar from "@/components/common/layout/MainToolbar";
import SearchSingleSelectBox from "@/components/input/SearchSingleSelectBox";
import {DateTime} from "luxon";
import BatchModal from "./BatchModal";
import DepositModal from "@/views/sales/DepositModal";
import SalesModal from "@/views/batch/SalesModal";
import selectOptions from "@/components/selectBox/selectOptions";
import BatchCheckDuplicateBillsComp from "@/views/batch/BatchCheckDuplicateBillsComp.vue";
import BatchCheckCompleteComp from "@/views/batch/BatchCheckCompleteComp.vue";
import BatchCheckMissBillsComp from "@/views/batch/BatchCheckMissBillsComp.vue";
import BatchCheckTaxComp from "@/views/batch/BatchCheckTaxComp.vue";
import BatchCheckMissCmsComp from "@/views/batch/BatchCheckMissCmsComp.vue";
import BatchCheckDuplicateCmsComp from "@/views/batch/BatchCheckDuplicateCmsComp.vue";
import BatchCheckTaxAfterComp from "@/views/batch/BatchCheckTaxAfterComp.vue";
import BatchCheckMonthlyUsageComp from "@/views/batch/BatchCheckMonthlyUsageComp.vue";
import BatchCheckPrinterUsageComp from "@/views/batch/BatchCheckPrinterUsageComp.vue";
import SearchBar from "@/components/input/new/SearchBar.vue";
import SearchSelectAutoComplete from "@/components/selectBox/SearchSelectAutoComplete.vue";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions.vue";

export default {
  name: "BatchListComp",
  components: {
    SearchSelectAutoComplete,
    SearchBar,
    DepositModal,
    MainLayout,
    MainHeader,
    MainBody,
    MainToolbar,
    SearchSingleSelectBox,
    AdminDatePicker,
    BatchModal,
    SalesModal
  },
  mixins: [TotalCodeOptions],
  data() {
    return {
      dialog: false,
      isLoading: false,
      searchOptions: {//배치, 날짜, 세금유무 selectBox에서 선택한 값을 담습니다.
        checkDate: null,
        batchType: null,
        confirmTaxStepYn: null,
        autoYn: 'Y',
        pageNumber: 1,
        pageSize: 500,
        rentalcompanyId: null,
      },
      duplicatedSalesShowOptions: 'T', //searchOptions와 다르게 변경시 요청을 안보내도 됩니다.
      options: { //TotalCodeOptions를 안쓰려고 하나씩 만들고 있습니다.
        duplicatedSalesShow: selectOptions.BATCH.DUPLICATE_SALES_SHOW,
        batchList: selectOptions.BATCH.BATCH_OPTIONS
      },
      sortOption: {
        sortName: null,
        sortOrder: 1,
      },
      dataList: [],
      resDuplicatedSalesData: [],//dataList는 변동될 가능성이 많기 때문에 원본데이터 유지용으로 만들었습니다.
      isModal: false,
      modalItem: null,
      salesListClickAutoSettingData: { //매출 확인 버튼 클릭시 전달할 데이터를 가공하기 위함입니다.
        rentalcompanyId: undefined,
        companyName: undefined
      },
      conveyDataDeposit: {
        rentalcompanyId: undefined,
        accountId: undefined,
        billingId: undefined,
      },

      missTotalCnt: 0,
      doubleTotalCnt: 0,
      outIssueTotalCnt: 0,
      failTotalCnt: 0,
      createTotalCnt: 0,
      unpublishedCnt: 0,
      currentPage: {
        key: 'B',
        component: BatchCheckDuplicateBillsComp
      },
      identifier: 0,
      componentsSelect: [
        {
          key: 'F',
          compName: '배치 종료 여부',
          comp: BatchCheckCompleteComp,
          title: '배치 종료 여부',
        },
        {
          // 중복 매출
          key: 'B',
          compName: 'BatchCheckDuplicateBillsComp',
          comp: BatchCheckDuplicateBillsComp,
          title: '중복 매출',
        },
        {
          // 누락 매출
          key: 'BO',
          compName: 'BatchCheckMissBillsComp',
          comp: BatchCheckMissBillsComp,
          title: '누락 매출',

        },
        {
          // 세금계산서
          key: 'T',
          compName: 'BatchCheckTaxComp',
          comp: BatchCheckTaxComp,
          title: '세금계산서',
        },
        {
          // 세금계산서 입금 확인 후 발행
          key: 'TA',
          compName: 'BatchCheckTaxAfterComp',
          comp: BatchCheckTaxAfterComp,
          title: '세금계산서 입금 확인 후 발행',
        },
        {
          // 누락 CMS
          key: 'C',
          compName: 'BatchCheckMissCmsComp',
          comp: BatchCheckMissCmsComp,
          title: '누락 CMS',
        },
        {
          // 중복 CMS
          key: 'CD',
          compName: 'BatchCheckDuplicateCmsComp',
          comp: BatchCheckDuplicateCmsComp,
          title: '중복 CMS',
        },
        {
          // 중복 CMS
          key: 'M',
          compName: 'BatchCheckMonthlyUsageComp',
          comp: BatchCheckMonthlyUsageComp,
          title: '월별사용량',
        },
        {
          key: 'P',
          compName: 'BatchCheckPrinterUsageComp',
          comp: BatchCheckPrinterUsageComp,
          title: '일별사용량 에러'
        }

      ]
    }

  },
  computed: {
    selectedBatchType() {
      return this.options.batchList.find(e => {
        if (e.codeKey == this.searchOptions.batchType) return true
      }).codeValue
    },
  },
  watch: {
    'searchOptions.batchType'(newVal) {
      this.selectPage(newVal)
    },


  },
  created() {
    this.init();
    this.loadCompanyOptions();
  },
  methods: {
    selectPage(key) {
      this.searchOptions.rentalcompanyId = null
      this.currentPage.key = key
      this.currentPage.component = this.componentsSelect.find(e => {
        return e.key === key
      }).comp
      this.identifier++
    },
    /**
     * 중복 매출에서 생성건수랑 예상건수가 다른 목록만 보기 위함입니다.}
     * @returns {[]}
     */
    diffCountDuplicateSalesList(e) {
      if (e === 'T') this.dataList = this.resDuplicatedSalesData
      else {
        this.dataList = this.resDuplicatedSalesData.filter((item) => {
          return item.createdCount !== item.targetCount
        })
      }
    },
    /**
     * 돈과 연관되있는 데이터는 3번째 자리에서 ,를 찍어줍니다
     * @param number
     * @returns {string}
     */
    numberFormat(number) {
      if (number === 0) return '0'
      if (!number) return ''
      return Number(number).toLocaleString()
    },

    usedDaysBackColorChange(e) {
      if (e > 31 || e < 25) {
        return {['used-day-back-color']: true}
      }
    },
    billingIdColorChange(e) {
      if (!e) return
      if (e.includes(':add')) {
        return {['billing-id-color-change']: true}
      }
    },

    init() {
      this.searchOptions.checkDate = DateTime.local().toISODate()
      this.searchOptions.batchType = 'F'
      this.searchOptions.confirmTaxStepYn = 'N'
    },
    /**
     * 세금계산서와 중복매출에서 매출 모달을 사용할 수 있습니다.
     * @param item
     */
    openSalesModal(rentalId, companyName) {
      this.salesListClickAutoSettingData = {
        companyName: companyName,
        rentalcompanyId: !!rentalId ? Number(rentalId) : undefined
      }
      this.dialog = true
    },
    /**
     * 중복CMS에서 입출금 모달을 사용할 수 있습니다.
     * @param item
     */
    openDepositModal(item) {
      this.conveyDataDeposit = {
        rentalcompanyId: item.rentalcompanyId,
        accountId: item.accountId,
        billingId: item.billingId,
      }
      this.dialog = true
    },
    closeSalesModal() {
      this.dialog = false
      this.rentalcompanyId = undefined
    },
    onFilterChanged(e) {
      if (!e || this.searchOptions.batchType === e) return
      this.dataList = null
      this.searchOptions.batchType = e
      this.resDuplicatedSalesData = null
    },
    /**
     * sorting 하는 함수입니다.
     *
     */
    sortOptionChange(e, type) {
      this.setSortOption(e);
      this.dataList.sort((a, b) => {
        let prev, next;
        if (type === "number") {//숫자일때 비교
          const numberA = Number(a[e])
          const numberB = Number(b[e])
          prev = numberA ? numberA : 0;
          next = numberB ? numberB : 0;
        } else { //문자일때 비교
          if (!!a[e]) {
            prev = a[e]
          } else if (a[e] === null) {
            prev = -1
          } else {
            prev = ''
          }
          if (!!b[e]) {
            next = b[e]
          } else if (b[e] === null) {
            next = -1
          } else {
            next = ''
          }
          // prev = a[e]?a[e]:'';
          // next = b[e]?b[e]:'';
        }
        if (prev < next) {//클때
          return -1 * this.sortOption.sortOrder;
        } else if (prev > next) {//작을때
          return 1 * this.sortOption.sortOrder;
        } else {//같을때
          return 0;
        }
      });
    },

    dataLoad() {
      if (this.isLoading) return;
      if (this.searchOptions.batchType == 'FL') this.reasonDataLoad()
      else if (this.searchOptions.batchType == 'US') this.MonthlyDataLoad()
      else if (this.searchOptions.batchType == 'BO') this.missingBillDataLoad()
      else if (this.searchOptions.batchType == 'CD') this.doubleCmsDataLoad()
      else if (this.searchOptions.batchType == 'T') this.baseTaxCheck()
      else if (this.searchOptions.batchType == 'TA') this.baseTaxCheckAfter()
      // else this.batchDataLoad()
    },

    MonthlyDataLoad() {
      this.initSort()
      this.isLoading = true;
      this.$request(PATH.BATCH.MONTHLY)
          .setObject({checkDate: this.searchOptions.checkDate})
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.isLoading = false;
            this.dataList = res.data.sort((prev, next) => {
              return prev.rentalcompanyId - next.rentalcompanyId;
            })
          });
    },

    missingBillDataLoad() {
      this.initSort()
      this.isLoading = true;
      this.$request(PATH.BATCH.MISSING_BILLING)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.isLoading = false;
            // this.dataList = res.data;
            this.dataList = res.data.sort((a, b) => {
              return ((b.billingId === null) - (a.billingId === null) || b.billingId - a.billingId);
            })
          });
    },

    baseTaxCheck() {
      this.initSort()
      this.isLoading = true;
      this.$request(PATH.BATCH.TAX_CHECK)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.isLoading = false;
            this.dataList = res.data;
          });
    },
    baseTaxCheckAfter() {
      this.initSort()
      this.isLoading = true;
      this.$request(PATH.BATCH.TAX_CHECK_AFTER)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.isLoading = false;
            this.dataList = res.data;
          });
    },

    doubleCmsDataLoad() {
      this.initSort()
      this.isLoading = true;
      this.$request(PATH.BATCH.DOUBLE_WITHDRAWAL)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.isLoading = false;
            this.dataList = res.data;
          });
    },
    //
    // /**
    //  * 데이터 리스트를 가져오는 요청 로직입니다.
    //  */
    // batchDataLoad() {
    //   this.initSort()
    //   this.isLoading = true
    //   this.$request(PATH.BATCH.CHECK)
    //       .setObject(this.searchOptions)
    //       .catch(e => {
    //         this.isLoading = false;
    //         alert("조회 실패")
    //       })
    //       .enqueue()
    //       .then(res => {
    //         this.isLoading = false;
    //         if (this.searchOptions.batchType == 'B') {//중복매출에서 중복건수는 상단으로 올립니다.
    //           const sortingData = res.data.sort((a, b) => {
    //             return (b.besideCount - a.besideCount) || (b.usageCount - a.usageCount);
    //           })
    //
    //           this.dataList = sortingData
    //           this.resDuplicatedSalesData = sortingData
    //         } else if (this.searchOptions.batchType == 'C') {//누락매출에서 누락건수는 상단으로 올립니다.
    //           this.dataList = res.data.sort((a, b) => {
    //             return ((b.resultValue === null) - (a.resultValue === null) || b.resultValue - a.resultValue);
    //           })
    //         } else if (this.searchOptions.batchType == 'T') {//세금계산서에서 미발행건은 상단으로 올립니다.
    //           this.dataList = res.data.sort((a, b) => {
    //             if (a.resultValue === b.resultValue) return 0
    //             else if (a.resultValue === '발행 안함') return -1
    //             else if (b.resultValue === '발행 안함') return 1
    //             else return 0
    //           })
    //         } else {
    //           this.dataList = res.data
    //         }
    //
    //       });
    // },
    reasonDataLoad() {
      //ffe79e
      this.initSort()
      this.isLoading = true;
      this.$request(PATH.BATCH.REASON)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.isLoading = false;
            this.dataList = res.data
          });
    },
    initSort() {
      this.sortOption = {
        sortName: null,
        sortOrder: 1,
      }
    },
    setSortOption(e) {
      if (e === this.sortOption.sortName) {
        this.sortOption.sortOrder *= -1
      } else {
        this.sortOption = {
          sortName: e,
          sortOrder: 1,
        }
      }
    },
    openModal(item) {
      console.log('### item', item)
      this.isModal = true
      this.modalItem = item
        this.modalItem.detailReason = ""
        this.modalItem.batchType = item.batchType
        this.modalItem.baseDt = this.searchOptions.checkDate
    },
    closeModal() {
      this.isModal = false
      this.modalItem = null
    },
    saveModal() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$request(PATH.BATCH.SAVEREASON)
          .setObject(this.modalItem)
          .catch(e => {
            this.isLoading = false;
            alert("저장 실패")
          })
          .enqueue()
          .then(e => {
            alert("저장 성공")
            this.closeModal()
            this.isLoading = false;
          })
    },
    deleteModal() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$request(PATH.BATCH.DELETE)
          .setObject(this.modalItem)
          .catch(e => {
            this.isLoading = false;
            alert("삭제 실패")
          })
          .enqueue()
          .then(e => {
            alert("삭제 성공")
            this.closeModal()
            this.isLoading = false;
            this.dataLoad();
          })
    },
    getDatetime(date) {
      if (date == null) return;

      return new Date(date).toTimeString().split(" ")[0];
    },
    /**
     * 특이사항으로 표시되는것들은 노란색으로 표시합니다.
     * @param idx
     * @returns {{backgroundColor: string}}
     */
    markConditionStyle(idx) {
      if (this.searchOptions.batchType == 'BO') {
        if (this.dataList[idx].billingId == null) {
          return {'backgroundColor': 'yellow'};
        }
      } else if (this.searchOptions.batchType == 'CD') {
        if (this.dataList[idx].cmsCount > 1) {
          return {'backgroundColor': 'yellow'};
        }
      } else if (this.searchOptions.batchType == 'B') {
        if (this.dataList[idx].besideCount > 1 || this.dataList[idx].usageCount > 1) {
          return {'backgroundColor': 'yellow'};
        }
      }
    },
  }
}
</script>

<style scoped>
.used-day-back-color {
  background-color: #ffe79e;
}

.billing-id-color-change {
  background-color: #ffe79e;
}

>>> input[type=checkbox] {
  position: absolute;
}

.main-con {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.main-con .data-table {
  position: relative;
  width: 100%;
  border-spacing: 0;
}

.main-con .data-table thead {
  position: sticky;
  top: 0;
  background: #ddd;
}

.main-con .data-table thead tr th {
  font-size: 13px;
}

.main-con .data-table tbody td {
  padding: 0.15rem;
  text-align: left;
  border: 1px solid #ccc;
  font-size: 13px;
}

.main-con .data-table tbody tr:nth-child(even) {
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover {
  background: #ddd;
}

/* 로딩 아이콘 시작 */
.loading_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}

.loading {
  width: 8px;
  height: 8px;
  background: #aaaaaa;
  border-radius: 50%;
  animation: loading-cricle 1.5s infinite ease-in-out;
  display: inline-block;
  margin-right: 8px;
}

.loading:nth-child(2) {
  animation-delay: .5s;
}

.loading:nth-child(3) {
  animation-delay: 1s;
}

@keyframes loading-cricle {
  0% {
    opacity: .4;
    transform: scale(1, 1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2, 1.2);
  }
  100% {
    opacity: .4;
    transform: scale(1, 1);
  }
}

.modal__title {
  padding: 8px;
  font-size: 24px !important;
  font-weight: bold;
  height: 40px;
}

.modal__close {
  position: absolute;
  height: 40px;
  padding: 4px;
  top: 12px;
  right: 12px;
  line-height: 32px;
  background: #eeeeee;
  border-radius: 4px;
}

.modal__detail {
  padding: 8px;
  margin: 18px 0;
  height: calc(100% - 132px);
}

.modal__detail table {
  border-spacing: 0;
  width: 100%;
  height: 100%;
}

.modal__detail table th {
  border: solid 1px #ddd;
  background: #ccc;
}

.modal__detail table td {
  border: solid 1px #ddd;
}

.modal__detail table textarea {
  width: calc(100% - 16px);
  height: calc(100% - 16px);
  margin: 8px;
}

.modal__footer {
  padding: 8px;
  font-size: 24px !important;
  font-weight: bold;
  height: 56px;
  display: flex;
  justify-content: space-evenly;
}

.modal__footer button {
  width: 40%;
  height: 100%;
  border: none;
  background: #eeeeee;
}
</style>
<style>
.font-bold {
  font-weight: bold;
}

.total_count {
  display: flex;
  float: right;
  font-weight: 500;
  color: #333;
}

.total_count2 {
  padding-right: 15px;
}

.table-text-center {
  text-align: center !important;
}

.table-text-right {
  text-align: right !important;
}

.short-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.width-pixel-40 {
  width: 40px !important;
}

.width-pixel-60 {
  width: 60px !important;
}

.width-pixel-80 {
  width: 80px !important;
}

.width-pixel-90 {
  width: 90px !important;
}

.width-pixel-100 {
  width: 100px !important;
}

.width-pixel-120 {
  width: 120px !important;
}

.width-pixel-200 {
  width: 200px !important;
}

.width-percent-2 {
  width: 2% !important;
}

.width-percent-4 {
  width: 4% !important;
}

.width-percent-8 {
  width: 8% !important;
}

.width-percent-10 {
  width: 8% !important;
}

.width-percent-14{
  width: 14% !important;
}
.width-percent-18 {
  width: 18% !important;
}


</style>
